var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"period-select"},[_c('base-select',{attrs:{"items":_vm.items,"value":_vm.statPeriod,"item-text":"name","item-value":"value","is-outlined":true},on:{"select":_vm.selectPeriod},scopedSlots:_vm._u([{key:"prepend-icon",fn:function(){return [_c('SvgChart',{staticClass:"icon"})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }